export default {
    add (payload, dataLayer = []) {
        dataLayer = window.dataLayer || dataLayer // Google Tag Manager
        dataLayer.push(payload)
    },
}
